(function () {
  function initCrossSellBlock(block) {
    if (!block || block.dataset.crossSellInitialized === 'true') return;

    const addAllButton = block.querySelector('.cross-sell-block__add-all');
    if (!addAllButton) return;

    block.dataset.crossSellInitialized = 'true';

    addAllButton.addEventListener('click', function () {
      if (addAllButton.getAttribute('aria-disabled') === 'true') return;

      const forms = block.querySelectorAll('product-form form[data-type="add-to-cart-form"]');
      const items = [];

      forms.forEach(function (form) {
        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton && submitButton.disabled) return;

        const variantInput = form.querySelector('input.product-variant-id[name="id"]');
        if (!variantInput || !variantInput.value) return;

        const properties = {};
        form.querySelectorAll('input[name^="properties["]').forEach(function (input) {
          const match = input.name.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = input.value;
        });

        items.push({
          id: Number(variantInput.value),
          quantity: 1,  
          properties: properties,
        });
      });

      if (!items.length) return;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const config = fetchConfig('javascript');
      const body = { items: items };

      if (cart) {
        body.sections = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      config.body = JSON.stringify(body);

      const spinner = addAllButton.querySelector('.loading-overlay__spinner');

      addAllButton.setAttribute('aria-disabled', 'true');
      addAllButton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      fetch(routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            console.error(response.description || response.message);
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cross-sell-add-all' });
          }

          cart.renderContents(response);

          try {
            if (window.bfTheme && window.bfTheme.syncDiscountFromCart) window.bfTheme.syncDiscountFromCart();
          } catch (e) {}

          try {
            window.bfTheme?.recalculateAllPrices?.();
          } catch (e) {}

          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          addAllButton.classList.remove('loading');
          addAllButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  }

  function initCrossSellBlocks() {
    document.querySelectorAll('[data-section="pdp-cross-sell"]').forEach(initCrossSellBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCrossSellBlocks);
  } else {
    initCrossSellBlocks();
  }

  document.addEventListener('shopify:section:load', initCrossSellBlocks);
})();
